const Sdata = [
  {
    id: 1,
    title: "50% Off On Womens Fashion",
    // desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quis lobortis consequat eu, quam etiam at quis ut convallis.",
    cover: "./images/SlideCard/slide-1.png",
  },
  {
    id: 2,
    title: "50% Off On Mens Fashion",
    // desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quis lobortis consequat eu, quam etiam at quis ut convallis.",
    cover: "./images/SlideCard/slide-3.png",
    link: "https://amzn.to/3KchR2J"
  },
  {
    id: 3,
    title: "50% Off On Shoes",
    // desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quis lobortis consequat eu, quam etiam at quis ut convallis.",
    cover: "./images/SlideCard/slide-2.png",
    link:"https://amzn.to/3GjNI0y"
  },
 
  {
    id: 4,
    title: "50% Off On Electronics",
    // desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quis lobortis consequat eu, quam etiam at quis ut convallis.",
    cover: "./images/SlideCard/slide-4.png",
    link:"https://amzn.to/3ZFJ3Nk"
  },
]
export default Sdata
